// Admin
export const SET_PRICE_SOURCE = 'SET_PRICE_SOURCE';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const SET_USER_SESSION = 'SET_USER_SESSION';
export const SET_TRIAL_DAYS_LEFT = 'SET_TRIAL_DAYS_LEFT';
export const SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';
export const SET_WEBSITES = 'SET_WEBSITES';
export const SET_SITE_BUILT = 'SET_SITE_BUILT';
export const SET_PUBLISH_ITEM = 'SET_PUBLISH_ITEM';
export const SAVE_NEW_SITE = 'SAVE_NEW_SITE';
export const SAVE_SITE_INFO = 'SAVE_SITE_INFO';
export const DELETE_SITE = 'DELETE_SITE';
export const PURCHASE_DOMAIN = 'PURCHASE_DOMAIN';
export const ADD_OWNED_DOMAIN = 'ADD_OWNED_DOMAIN';
export const LATE_TRANSFER_DOMAIN = 'LATE_TRANSFER_DOMAIN';
export const DELETE_DOMAIN = 'DELETE_DOMAIN';
export const ADD_DOMAIN_RECORD = 'ADD_DOMAIN_RECORD';
export const REMOVE_DOMAIN_RECORD = 'REMOVE_DOMAIN_RECORD';
export const UPDATE_DOMAIN_RECORD = 'UPDATE_DOMAIN_RECORD';
export const ENABLE_AUTO_RENEW = 'ENABLE_AUTO_RENEW';
export const UPDATE_DOMAIN = 'UPDATE_DOMAIN';
export const UPDATE_SITE_STATUS = 'UPDATE_SITE_STATUS';
export const INVITE_USER = 'INVITE_USER';
export const GET_USERS = 'GET_USERS';
export const SET_SUBUSERS = 'SET_SUBUSERS';
export const SET_SUBUSERS_FETCHED = 'SET_SUBUSERS_FETCHED';
export const SET_TICKET_USER = 'SET_TICKET_USER';
export const SET_CURRENT_USER_PROFILE_PIC = 'SET_CURRENT_USER_PROFILE_PIC';
export const ADD_SITE_SSL = 'ADD_SITE_SSL';
export const REMOVE_SITE_SSL = 'REMOVE_SITE_SSL';
export const SET_CERT_ACTIVE = 'SET_CERT_ACTIVE';
export const SET_USER_POOL = 'SET_USER_POOL';
export const SET_USER_IDENTITY_ID = 'SET_USER_IDENTITY_ID';
export const SET_USER_ATTRIBUTES = 'SET_USER_ATTRIBUTES';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USER_ATTRIBUTE = 'SET_USER_ATTRIBUTE';
export const SET_FIRST_LOGIN = 'SET_FIRST_LOGIN';
export const ADD_EMPTY_FOLDER_QUEUE = 'ADD_EMPTY_FOLDER_QUEUE';
export const SET_ALERT_STATUS = 'SET_ALERT_STATUS';
export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const SET_GLOBAL_NEW_VALUES = 'SET_GLOBAL_NEW_VALUES';
export const SET_GLOBAL_VALUE = 'SET_GLOBAL_VALUE';
export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';
export const READD_GLOBAL_ARRAY = 'READD_GLOBAL_ARRAY';
export const RUN_STATE_FN = 'RUN_STATE_FN';
export const SET_DATA_ORIGIN = 'SET_DATA_ORIGIN';

export const SET_CURRENT_SITE = 'SET_CURRENT_SITE';
export const SET_ACTIVE_SITE_TYPE = 'SET_ACTIVE_SITE_TYPE';
export const ADD_PAGE = 'ADD_PAGE';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_PAGE_LINKS = 'UPDATE_PAGE_LINKS';
export const SET_CANVAS_PAGE = 'SET_CANVAS_PAGE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const UPDATE_ALL_REFERENCES = 'UPDATE_ALL_REFERENCES';
export const UPDATE_INITIAL_PAGE = 'UPDATE_INITIAL_PAGE';
export const REVERT_PAGE = 'REVERT_PAGE';
export const RECEIVE_PAGES = 'RECEIVE_PAGES';
export const REMOVE_PAGE = 'REMOVE_PAGE';
export const REPLACE_QUEUED_PAGE = 'REPLACE_QUEUED_PAGE';
export const SET_SITE_SAVED = 'SET_SITE_SAVED';
export const RM_PAGE_SUCCESS = 'RM_PAGE_SUCCESS';
export const RM_PAGE_FAILURE = 'RM_PAGE_FAILURE';
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';
export const UNLINK_TEMPLATE = 'UNLINK_TEMPLATE';
export const SET_FETCH_ERROR = 'SET_FETCH_ERROR';
export const UPDATE_PAGE_TEMPLATE_BLOCK = 'UPDATE_PAGE_TEMPLATE_BLOCK';
export const REMOVE_PAGE_TEMPLATE_BLOCK = 'REMOVE_PAGE_TEMPLATE_BLOCK';
export const INJECT_TEMPLATE = 'INJECT_TEMPLATE';
export const REMOVE_TEMPLATE = 'REMOVE_TEMPLATE';
export const SET_PUBLISH_BOILERPLATE = 'SET_PUBLISH_BOILERPLATE';
export const SET_ORIGINAL_PAGE = 'SET_ORIGINAL_PAGE';
export const ADD_TO_HISTORY = 'ADD_TO_HISTORY';
export const TOGGLE_HISTORY = 'TOGGLE_HISTORY';
export const SET_ORDERS_LOADED = 'SET_ORDERS_LOADED';
export const SET_STORE_ORDERS = 'SET_STORE_ORDERS';

export const SET_SITE_THEME = 'SET_SITE_THEME';
export const REARRANGE_SITE_MAP = 'REARRANGE_SITE_MAP';
export const SET_SITE_MAP = 'SET_SITE_MAP';
export const REMOVE_FROM_SITE_MAP = 'REMOVE_FROM_SITE_MAP';
export const ADD_TO_SITE_MAP = 'ADD_TO_SITE_MAP';
export const SET_FAVICON = 'SET_FAVICON';
export const ADD_SITE_FONT = 'ADD_SITE_FONT';
export const REMOVE_SITE_FONT = 'REMOVE_SITE_FONT';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
export const RECEIVE_TEMPLATES = 'RECEIVE_TEMPLATES';
export const ADD_DRAFT = 'ADD_DRAFT';
export const RECEIVE_DRAFTS = 'RECEIVE_DRAFTS';
export const SET_BOILERPLATES = 'SET_BOILERPLATES';
export const REMOVE_BOILERPLATE = 'REMOVE_BOILERPLATE';
export const SET_TOOLBAR_STATUS = 'SET_TOOLBAR_STATUS';
export const SET_GLOBAL_VIEWPORT = 'SET_GLOBAL_VIEWPORT';
export const SET_GLOBAL_BUBBLE_STATUS = 'SET_GLOBAL_BUBBLE_STATUS';
export const SET_NEW_SITE_VALUES = 'SET_NEW_SITE_VALUES';
export const CHANGE_GLOBAL_PAGE_CSS = 'CHANGE_GLOBAL_PAGE_CSS';
export const CHANGE_SITE_PAGE_CSS = 'CHANGE_SITE_PAGE_CSS';
export const SET_GLOBAL_OPTIONS_HOVER = 'SET_GLOBAL_OPTIONS_HOVER';
export const SET_GLOBAL_OPEN_MODAL = 'SET_GLOBAL_OPEN_MODAL';
export const REVERT_DROPLET_COUNTS = 'REVERT_DROPLET_COUNTS';

// Section
export const UPLOAD_FILE = 'UPLOAD_FILE';

// Drag & Drop mutations
export const DROP_NEW_DROPLET = 'DROP_NEW_DROPLET';
export const MOVE_DROPLET = 'MOVE_DROPLET';
export const FIRST_DROP_STATUS = 'FIRST_DROP_STATUS';
export const SET_GLOBAL_DRAG_ITEM = 'SET_GLOBAL_DRAG_ITEM';
export const SET_DRAGGING = 'SET_DRAGGING';
export const SET_VNODE_DRAG_ID = 'SET_VNODE_DRAG_ID';
export const SET_DROPPED_ID = 'SET_DROPPED_ID';

// Sections
export const ADD_CONTENT_BLOCK = 'ADD_CONTENT_BLOCK';
export const REMOVE_CONTENT_BLOCK = 'REMOVE_CONTENT_BLOCK';
export const REVERT_SECTION = 'REVERT_SECTION';
export const SET_SECTION_ERROR = 'SET_SECTION_ERROR';
export const SET_SECTION_HINT = 'SET_SECTION_HINT';
export const SET_SECTION_ID = 'SET_SECTION_ID';
export const UPDATE_SECTION_VAL = 'UPDATE_SECTION_VAL';

export const SET_SITE_RGBA = 'SET_SITE_RGBA';
export const SET_SITE_PICKER = 'SET_SITE_PICKER';

// Global droplet options
export const TOGGLE_DROPLETS = 'TOGGLE_DROPLETS';
export const FETCH_DROPLETS = 'FETCH_DROPLETS';
export const SET_PUDDLE_FILTER = 'SET_PUDDLE_FILTER';
export const ADD_DROPLET = 'ADD_DROPLET';
export const REMOVE_DROPLET = 'REMOVE_DROPLET';
export const REVERT_DROPLET = 'REVERT_DROPLET';
export const SET_DROPLET_POSITION = 'SET_DROPLET_POSITION';
export const ADD_SHAREABLE_DROPLET = 'ADD_SHAREABLE_DROPLET';
export const MOD_SHAREABLE_TRIGGER = 'MOD_SHAREABLE_TRIGGER';
export const LOAD_SHAREABLE_DROPLET = 'LOAD_SHAREABLE_DROPLET';
export const LOAD_SHAREABLES = 'LOAD_SHAREABLES';
export const BOUNCE_DROPLET = 'BOUNCE_DROPLET';
export const UPDATE_S3_QUEUE = 'UPDATE_S3_QUEUE';
export const CHANGE_DROPLET_CSS = 'CHANGE_DROPLET_CSS';
export const CHANGE_DROPLET_PAGE_CSS = 'CHANGE_DROPLET_PAGE_CSS';
export const SETUP_NEW_DROPLET_STYLES = 'SETUP_NEW_DROPLET_STYLES';
export const SET_NEW_DROPLET_VALUES = 'SET_NEW_DROPLET_VALUES';
export const SET_DROPLET_VAL = 'SET_DROPLET_VAL';
export const PUSH_DROPLET_VAL = 'PUSH_DROPLET_VAL';
export const SPLICE_DROPLET_VAL = 'SPLICE_DROPLET_VAL';
export const PREPEND_DROPLET_VAL = 'PREPEND_DROPLET_VAL';
export const REPLACE_DROPLET_VAL = 'REPLACE_DROPLET_VAL';
export const SET_ACTIVE_DROPLET = 'SET_ACTIVE_DROPLET';
export const SET_ACTIVE_DROPLET_ITEM = 'SET_ACTIVE_DROPLET_ITEM';
export const SET_ACTIVE_STATE = 'SET_ACTIVE_STATE';
export const SET_ANIMATION_PREVIEW = 'SET_ANIMATION_PREVIEW';
export const SET_LOCAL_STYLES = 'SET_LOCAL_STYLES';
export const SET_DROPLET_OBSERVER = 'SET_DROPLET_OBSERVER';
export const TOGGLE_STYLE_SIDEBAR = 'TOGGLE_STYLE_SIDEBAR';
export const CALL_PLUGIN_BOUNCE = 'CALL_PLUGIN_BOUNCE';
export const SET_STYLE_CONDITION = 'SET_STYLE_CONDITION';

// Global notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const UPDATE_ONLINE_STATUS = 'UPDATE_ONLINE_STATUS';
export const EMPTY_OFFLINE_WARNINGS = 'EMPTY_OFFLINE_WARNINGS';
export const ADD_OFFLINE_WARNING = 'ADD_OFFLINE_WARNING';
export const SET_PREVIEW_OPTIONS = 'SET_PREVIEW_OPTIONS';
export const SET_SAVE_OPTIONS = 'SET_SAVE_OPTIONS';
export const UPDATE_ROUTE = 'UPDATE_ROUTE';
export const UPDATE_RELOGIN = 'UPDATE_RELOGIN';
export const SET_BROWSER = 'SET_BROWSER';

// Droplets mutations

// Nav
export const SET_NAV_LINK_TITLE = 'SET_NAV_LINK_TITLE';
export const ADD_NAV_LINK = 'ADD_NAV_LINK';
export const REMOVE_NAV_LINK = 'REMOVE_NAV_LINK';
export const REARRANGE_NAV_LINKS = 'REARRANGE_NAV_LINKS';
export const SET_NAV_LINK_HREF = 'SET_NAV_LINK_HREF';
export const SET_NAV_LINK_WINDOW = 'SET_NAV_LINK_WINDOW';
export const SET_NAV_LOGO = 'SET_NAV_LOGO';
export const SET_NAV_LOGO_IMG = 'SET_NAV_LOGO_IMG';
export const SET_NAV_SCROLL_TYPE = 'SET_NAV_SCROLL_TYPE';
export const SET_NAV_SLIDE_DIRECTION = 'SET_NAV_SLIDE_DIRECTION';
export const SET_NAV_ACTIVE_LINK = 'SET_NAV_ACTIVE_LINK';
// General text
export const UPDATE_GENERAL_TEXT = 'UPDATE_GENERAL_TEXT';
// Header
export const UPDATE_HEADER_TEXT = 'UPDATE_HEADER_TEXT';
// Button
export const SET_BTN_TEXT = 'SET_BTN_TEXT';
export const SET_BTN_LINK = 'SET_BTN_LINK';
// Audio Player
export const SET_AUDIO_URL = 'SET_AUDIO_URL';
// Video Player
export const SET_VIDEO_URL = 'SET_VIDEO_URL';
// Countdown
export const ADD_COUNTDOWN_SET = 'ADD_COUNTDOWN_SET';
export const REMOVE_COUNTDOWN_SET = 'REMOVE_COUNTDOWN_SET';
export const SET_COUNTDOWN_BUFFER_DUR = 'SET_COUNTDOWN_BUFFER_DUR';
export const SET_COUNTDOWN_END_MSG = 'SET_COUNTDOWN_END_MSG';
export const SET_COUNTDOWN_RECUR = 'SET_COUNTDOWN_RECUR';
export const SET_COUNTDOWN_BUFFER_TIME = 'SET_COUNTDOWN_BUFFER_TIME';
export const SET_COUNTDOWN_END_TIME = 'SET_COUNTDOWN_END_TIME';
export const SET_COUNTDOWN_END_DATE = 'SET_COUNTDOWN_END_DATE';
export const SET_COUNTDOWN_FINAL_END = 'SET_COUNTDOWN_FINAL_END';
// Map
export const ADD_MAP_MARKER = 'ADD_MAP_MARKER';
export const REMOVE_MAP_MARKER = 'REMOVE_MAP_MARKER';
export const SET_MAP_MARKER_TITLE = 'SET_MAP_MARKER_TITLE';
export const SET_MAP_MARKER_ADDRESS = 'SET_MAP_MARKER_ADDRESS';
export const SET_MAP_MARKER_IMG = 'SET_MAP_MARKER_IMG';
// Social Media
export const SET_SOCIAL_ACTIVE = 'SET_SOCIAL_ACTIVE';
export const SET_SOCIAL_LINK = 'SET_SOCIAL_LINK';
// Columns
export const ADD_COLUMN = 'ADD_COLUMN';
export const REMOVE_COLUMN = 'REMOVE_COLUMN';
export const SET_COLUMN_WIDTH = 'SET_COLUMN_WIDTH';
export const SET_COLUMN_HEIGHTS = 'SET_COLUMN_HEIGHTS';
// Accordion
export const ADD_ACC_SECTION = 'ADD_ACC_SECTION';
export const REMOVE_ACC_SECTION = 'REMOVE_ACC_SECTION';
export const SET_ACC_TITLE = 'SET_ACC_TITLE';
// Tabs
export const ADD_TAB = 'ADD_TAB';
export const REMOVE_TAB = 'REMOVE_TAB';
export const SET_TAB_TITLE = 'SET_TAB_TITLE';
export const SET_TAB_LAYOUT = 'SET_TAB_LAYOUT';
// Footer Nav
export const SET_FOOTERNAV_LINK_TITLE = 'SET_FOOTERNAV_LINK_TITLE';
export const SET_FOOTERNAV_LINK_HREF = 'SET_FOOTERNAV_LINK_HREF';
export const SET_FOOTERNAV_LINK_WINDOW = 'SET_FOOTERNAV_LINK_WINDOW';
export const ADD_FOOTERNAV_LINK = 'ADD_FOOTERNAV_LINK';
export const REMOVE_FOOTERNAV_LINK = 'REMOVE_FOOTERNAV_LINK';
export const REARRANGE_FOOTERNAV_LINKS = 'REARRANGE_FOOTERNAV_LINKS';
export const SET_FOOTER_NAV_ACTIVE_LINK = 'SET_FOOTER_NAV_ACTIVE_LINK';
// Tables
export const ADD_TABLE_ROW = 'ADD_TABLE_ROW';
export const REMOVE_TABLE_ROW = 'REMOVE_TABLE_ROW';
export const ADD_TABLE_COLUMN = 'ADD_TABLE_COLUMN';
export const REMOVE_TABLE_COLUMN = 'REMOVE_TABLE_COLUMN';
export const SET_TABLE_HEADER_TEXT = 'SET_TABLE_HEADER_TEXT';
export const SET_TABLE_TD_TEXT = 'SET_TABLE_TD_TEXT';
// Tall Cards
export const ADD_NEW_TALL_CARD = 'ADD_NEW_TALL_CARD';
export const REMOVE_TALL_CARD = 'REMOVE_TALL_CARD';
export const SET_TALL_CARD_TEXT = 'SET_TALL_CARD_TEXT';
export const SET_TALL_CARD_HREF = 'SET_TALL_CARD_HREF';
export const SET_TALL_CARD_WINDOW = 'SET_TALL_CARD_WINDOW';
export const SET_TALL_CARD_ACTIVE_CARD = 'SET_TALL_CARD_ACTIVE_CARD';
// General Cards
export const ADD_NEW_GENERAL_CARD = 'ADD_NEW_GENERAL_CARD';
export const REMOVE_GENERAL_CARD = 'REMOVE_GENERAL_CARD';
export const SET_GENERAL_CARD_TEXT = 'SET_GENERAL_CARD_TEXT';
export const SET_GENERAL_CARD_HREF = 'SET_GENERAL_CARD_HREF';
export const SET_GENERAL_CARD_WINDOW = 'SET_GENERAL_CARD_WINDOW';
export const SET_GENERAL_CARD_ACTIVE_CARD = 'SET_GENERAL_CARD_ACTIVE_CARD';
// Wide Cards
export const ADD_NEW_WIDE_CARD = 'ADD_NEW_WIDE_CARD';
export const REMOVE_WIDE_CARD = 'REMOVE_WIDE_CARD';
export const SET_WIDE_CARD_TEXT = 'SET_WIDE_CARD_TEXT';
export const SET_WIDE_CARD_HREF = 'SET_WIDE_CARD_HREF';
export const SET_WIDE_CARD_WINDOW = 'SET_WIDE_CARD_WINDOW';
export const SET_WIDE_CARD_ACTIVE_CARD = 'SET_WIDE_CARD_ACTIVE_CARD';
// Event Cards
export const ADD_NEW_EVENT_CARD = 'ADD_NEW_EVENT_CARD';
export const REMOVE_EVENT_CARD = 'REMOVE_EVENT_CARD';
export const SET_EVENT_CARD_TEXT = 'SET_EVENT_CARD_TEXT';
// Step Cards
export const ADD_NEW_STEP_CARD = 'ADD_NEW_STEP_CARD';
export const REMOVE_STEP_CARD = 'REMOVE_STEP_CARD';
export const SET_STEP_CARD_TEXT = 'SET_STEP_CARD_TEXT';
export const SET_STEP_CARD_HREF = 'SET_STEP_CARD_HREF';
export const SET_STEP_CARD_WINDOW = 'SET_STEP_CARD_WINDOW';
export const SET_STEP_CARD_ACTIVE_CARD = 'SET_STEP_CARD_ACTIVE_CARD';
// General Code
export const UPDATE_CODE = 'UPDATE_CODE';
export const SET_CODE_HIDDEN = 'SET_CODE_HIDDEN';
// Content Slider
export const ADD_CONTENT_SLIDER_ITEM = 'ADD_CONTENT_SLIDER_ITEM';
export const REMOVE_CONTENT_SLIDER_ITEM = 'REMOVE_CONTENT_SLIDER_ITEM';
export const SET_CONTENT_SLIDER_DELAY = 'SET_CONTENT_SLIDER_DELAY';
export const SET_CONTENT_SLIDER_EFFECT = 'SET_CONTENT_SLIDER_EFFECT';
export const SET_CONTENT_SLIDER_BULLETS = 'SET_CONTENT_SLIDER_BULLETS';
export const SET_CONTENT_SLIDER_CONTROLS = 'SET_CONTENT_SLIDER_CONTROLS';
export const SET_CONTENT_SLIDER_LIMITS = 'SET_CONTENT_SLIDER_LIMITS';
export const SET_CONTENT_SLIDER_FIRST = 'SET_CONTENT_SLIDER_FIRST';
// Carousel
export const ADD_CAROUSEL_IMAGE = 'ADD_CAROUSEL_IMAGE';
export const REMOVE_CAROUSEL_IMAGE = 'REMOVE_CAROUSEL_IMAGE';
export const SET_CAROUSEL_DELAY = 'SET_CAROUSEL_DELAY';
export const SET_CAROUSEL_VISIBLE_NUM = 'SET_CAROUSEL_VISIBLE_NUM';
export const SET_CAROUSEL_CONTROLS = 'SET_CAROUSEL_CONTROLS';
export const SET_CAROUSEL_LIMITS = 'SET_CAROUSEL_LIMITS';
export const SET_CAROUSEL_FIRST = 'SET_CAROUSEL_FIRST';
// Image Gallery
export const ADD_IMAGE_GALLERY_IMAGE = 'ADD_IMAGE_GALLERY_IMAGE';
export const SET_IMAGE_GALLERY_LIMITS = 'SET_IMAGE_GALLERY_LIMITS';
export const REMOVE_IMAGE_GALLERY_IMAGE = 'REMOVE_IMAGE_GALLERY_IMAGE';
export const SET_IMAGE_GALLERY_FIRST = 'SET_IMAGE_GALLERY_FIRST';
// Image General
export const SET_GENERAL_IMG_SRC = 'SET_GENERAL_IMG_SRC';
// Youtube Video
export const SET_YOUTUBE_SRC = 'SET_YOUTUBE_SRC';
export const SET_YOUTUBE_AUTOPLAY = 'SET_YOUTUBE_AUTOPLAY';
// Form
export const RESET_FORM_EDITING = 'RESET_FORM_EDITING';
export const SET_FORM_BTN_TXT = 'SET_FORM_BTN_TXT';
export const SET_FORM_FIELD_EDIT_TABS = 'SET_FORM_FIELD_EDIT_TABS';
export const SET_FORM_ACTIVE_FIELD = 'SET_FORM_ACTIVE_FIELD';
export const SET_FORM_ACTIVE_FIELD_ID = 'SET_FORM_ACTIVE_FIELD_ID';
export const SET_FORM_ACTIVE_FIELD_INDEX = 'SET_FORM_ACTIVE_FIELD_INDEX';
export const REMOVE_FORM_FIELD = 'REMOVE_FORM_FIELD';
export const SET_FORM_FIELD_LABEL = 'SET_FORM_FIELD_LABEL';
export const SET_FORM_FIELD_REQUIRED = 'SET_FORM_FIELD_REQUIRED';
export const SET_FORM_FIELD_TOOLTIP = 'SET_FORM_FIELD_TOOLTIP';
export const SET_FORM_FIELD_PLACEHOLDER = 'SET_FORM_FIELD_PLACEHOLDER';
export const SET_FORM_FIELD_NO_LABEL = 'SET_FORM_FIELD_NO_LABEL';
export const SET_FORM_FIELD_OTHER = 'SET_FORM_FIELD_OTHER';
export const SET_FORM_FIELD_OPTION = 'SET_FORM_FIELD_OPTION';
export const REMOVE_FORM_FIELD_OPTION = 'REMOVE_FORM_FIELD_OPTION';
export const ADD_FORM_FIELD_OPTION = 'ADD_FORM_FIELD_OPTION';
export const ADD_FORM_COUNT = 'ADD_FORM_COUNT';
// Shareables
export const RM_ASSET_SUCCESS = 'RM_ASSET_SUCCESS';
export const RM_ASSET_FAILURE = 'RM_ASSET_FAILUE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js